import React from 'react';
import PropTypes from 'prop-types';
import { SelectField, TextField } from 'react-admin';
import EjectedSelectField from '../../../components/ejected/SelectField';
import EjectedBooleanField from '../../../components/ejected/BooleanField';
import EjectedDatagrid from '../../../components/ejected/Datagrid';

import TextLabelWithDate from '../../../components/TextFieldWithDate';

import { STATUSES, VISITED } from '../../../common';
import AddClientButton from '../../../components/AddClientButton';
import ClientNameButton from '../../../components/ClientNameButton';

const Datagrid = ({
  edit, create, total, companies, callcenters, toggleEdit, toggleCreate, subjects, ...rest
}) => (
  <EjectedDatagrid
    currentSort={{ order: 'ASC' }}
    create={create}
    edit={edit}
    width="867px"
    {...rest}
  >
    <SelectField
      label="Юр. Компания"
      source="companyId"
      choices={companies}
      customstyles={{
        width: '100px'
      }}
    />
    <SelectField choices={callcenters} optionText="shortName" source="callcenterId" label="КЦ" customstyles={{ width: '36px' }} />
    <ClientNameButton
      source="fio"
      label="ФИО"
      edit={toggleEdit}
      customstyles={{
        width: '94px',
      }}
    />
    <TextLabelWithDate
      source="time"
      label="Время"
      customstyles={{
        width: '62px',
      }}
    />
    <EjectedSelectField
      source="status_callcenter"
      label="Статус"
      choices={STATUSES}
      optionText="shortName"
      customstyles={{
        background: '#9B69DB',
        width: '68px'
      }}
    />
    <TextField
      source="phone"
      label="Телефон"
      customstyles={{
        width: '84px',
      }}
    />
    <SelectField
      label="Тематика"
      source="subject_new"
      choices={subjects}
      customstyles={{
        width: '80px'
      }}
      optionValue="key"
      optionText="name"
    />
    <TextField
      source="subject_text"
      label="Вопрос"
      customstyles={{
        width: '100px',
      }}
    />
    <AddClientButton
      style={{ textAlign: 'center' }}
      label="Приход"
      create={toggleCreate}
      source="visited"
      choices={VISITED}
      optionText="name"
      customstyles={{
        background: '#35CD59',
        width: '60px',
      }}
    />
    {/*<EjectedSelectField*/}
      {/*source="visited"*/}
      {/*label="Приход"*/}
      {/*choices={VISITED}*/}
      {/*optionText="name"*/}
      {/*customstyles={{*/}
        {/*background: '#35CD59',*/}
        {/*width: '60px',*/}
      {/*}}*/}
    {/*/>*/}
    <EjectedBooleanField
      source="treaty"
      label="Договор"
      customstyles={{
        background: '#B29C6A',
        width: '70px'
      }}
      color="#B29C6A"
    />
  </EjectedDatagrid>
);

Datagrid.defaultProps = {
  companies: [],
  subjects: []
};

Datagrid.propTypes = {
  create: PropTypes.func,
  edit: PropTypes.func,
  toggleCreate: PropTypes.func,
  toggleEdit: PropTypes.func,
  companies: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired
  })),
  callcenters: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    shortName: PropTypes.string.isRequired
  })),
  subjects: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
  }))
};

export default Datagrid;



// WEBPACK FOOTER //
// ./src/pages/company/customer/Datagrid.js